<template>
    <span class="playing" @click="click">
      <font class="iconfont" v-if="step==1">&#xe729;</font>
      <font class="iconfont" v-if="step==2">&#xe728;</font>
      <font class="iconfont" v-if="step==3">&#xe725;</font>
    </span>
</template>

<script>
import {audioPlayStatusCache} from "../lib/cache";
import {debug, isEmpty} from "../lib/util";

export default {
  name: 'v-audio-play-icon',
  props: ['src'],
  data() {
    return {
      audioStatus: '',
      step: 3,
      timer: null,
      status: ''
    };
  },
  computed: {},
  components: {},
  created() {

  },
  mounted() {
  },
  beforeDestroy() {
    this.clearCheck()
  },
  watch: {},
  methods: {
    click() {
      //return this.downloadAPP();
      this.$emit('click');
      this.check();
    },
    check() {
      const el = document.getElementById('uuidAudio');
      if (el) {
        Log('el', el.src);
        if (el.src === this.src) {
          Log('是本', this.src, el.paused);
          if (!el.paused) {
            if (this.status !== 'playing')
              this.playing();
          } else {
            this.pause();
          }
        } else {
          this.pause();
          Log('不是本', this.src);
        }
      }
      this.clearCheck();
      this.timerCheck = setTimeout(() => this.check(), 300);
    },
    clearCheck() {
      if (this.timerCheck)
        clearTimeout(this.timerCheck)
      this.timerCheck = null
    },
    pause() {
      this.clear();
      this.status = 'paused';
      this.timer = null;
      this.step = 3;
    },
    clear() {
      if (this.timer)
        clearTimeout(this.timer);
      this.timer = null;
    },
    playing() {
      this.status = 'playing';
      this.step++;
      if (this.step > 3) {
        this.step = 1;
      }
      this.clear();
      if (!this.timer) {
        this.timer = setTimeout(this.playing, 300);
      }
    }
  }
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/plugins/playing.vue